import React from 'react';
import styled from 'styled-components';
import { LabelButton, TrevorIcon } from '@trevor/ui-components';
import { hasInsightError } from '@/views/SavedQueries/helpers';
import { SavedQueryMeta } from '@/views/SavedQueries/types';
import { TShareOption } from '@/features/share-modal/ShareModal.constants';
import { InsightError } from './InsightError';
import { transformMetaToButtonsData } from './helpers';

const ButtonsContainer = styled.div`
  padding-top: 10px;
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;

  &:empty {
    display: none;
  }
`;

export type ConnectedToolsButtonsProps = {
  meta: SavedQueryMeta;
  onNavigateToDashboard: F<string>;
  onShare: F<TShareOption, F0>;
  dashboardsById: Record<string, { name: F0<string> }>;
};

export const ConnectedToolsButtons: React.FC<ConnectedToolsButtonsProps> = ({
  meta,
  onShare,
  onNavigateToDashboard,
  dashboardsById,
}) => (
  <ButtonsContainer>
    {transformMetaToButtonsData(
      meta,
      dashboardsById,
      onShare,
      onNavigateToDashboard,
    ).map((props) => (
      <ToolButton key={props.text} {...props} />
    ))}
    {hasInsightError(meta) && <InsightError message={meta.errorMsg()} />}
  </ButtonsContainer>
);

const ToolButton: React.FC<any> = ({ text, iconName, onClick }) => {
  return (
    <LabelButton
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      icon={<TrevorIcon name={iconName} $color="#666" />}
    >
      {text}
    </LabelButton>
  );
};
